import React from "react";
import { Box, useTheme } from "@mui/material";

const TitledBackground = ({ title, children }) => {
  const colourTheme = useTheme();
  return (
    <Box
      sx={{
        backdropFilter: "blur(1rem)",
        boxShadow: "0 0 1rem rgba(0, 0, 0, 0.2)",
        width: "100%",
        border: `1px solid ${colourTheme.palette.text.primary}`,
        borderRadius: "1rem",
        m: "auto",
        mb: 2.5,
        p: 1.5,
      }}
    >
      <p style={{ fontSize: "0.65rem", lineHeight: "0rem", marginTop: 0 }}>
        {title}
      </p>
      {children}
    </Box>
  );
};

export default TitledBackground;
